import { iPadBrowser } from "../helpers/browserDetect";
import { ie } from "../helpers/browserDetect";
import { logDetailed } from "../helpers/utils";

export function print(content) {
  logDetailed("print", "print", "trying to print", content);
  return new Promise((resolve) => doPrint(content, resolve));
}

function doPrint(content, resolve) {
  let newWindow = window.open("printPreview");
  newWindow.document.write(content);

  if (iPadBrowser) {
    window.onfocus = function () {
      setTimeout(() => {
        newWindow.close()
        resolve();
      }, 1000);
    };
    newWindow.print();
    window.focus();
  } else {
    if(ie){
      newWindow.document.close();
    }
    newWindow.print();
    newWindow.close();
    resolve();
  }
}

export function formatPrintContent(html, displayHeader, pageLayout, imagesPerSheet) {
  var content = `
    <!DOCTYPE html>
    <html>
    <head>
    <title>Print Preview</title>
    <style>
    * {
      box-sizing: border-box !important;
    }

    html {
      min-height: 100%;
    }

    html, 
    body, 
    .print-body, 
    .print-body-pages-wrapper, 
    .print-body-page-layout,
    .print-body-page-container,
    .print-body-page-inner-wrapper {
      height: 100%;
    }

    * {
      overflow: visible !important;
      color-adjust: exact !important;
      text-align: center
    }

    ::-webkit-scrollbar {
      width: 0 !important; 
      display: none;
    }

    body {
      margin-top: 0px;
      margin-bottom: 0px;
      overflow: auto;
    }

    .last {
      page-break-after: avoid;
    }

    .four {
      width: 50%;
      height: calc(50% - 20px / 2);
    }

    .nine {
      width: 33%;
      height: calc(33% - 20px / 3);
    }

    .nine .header {
      font-size: 10px;
    }

    .sixteen {
      width: 25%;
      height: calc(25% - 20px / 4);
    }

    .sixteen .header {
      font-size: 10px;
    }

    .leftPortraitBtn {
        visibility: hidden;
    }
    .rightPortraitBtn {
        visibility: hidden;
    }
    .leftLandscapeBtn {
        visibility: hidden;
    }
    .rightLandscapeBtn {
        visibility: hidden;
    }`;

  if (displayHeader)
    content += `
    .header {
      color: black;
      margin-right: 13px;
      font-size: 14px;
    }

    .imageHeader {
      background-color: #ffffff;
      border-bottom: 1px solid black;
    }`;

  else   
    content += `
    .header {
      height: 0px;
    }

    .imageHeader {
      height: 0px;
      background-color: #ffffff;
      border-bottom: 1px solid black;
    }`;

  if (imagesPerSheet != 1 && !displayHeader)
    content += `
    .one {
      width: 100%;
      height: calc(100% - 20px);
    }

    .panel {
      display: inline-block;
      border: 1px solid black;
      background-color: #ffffff;
    }
    
    @media print {
      @page {
        margin: 0;
        size: ${pageLayout};
      }
    }`;
  
  else 
    content += `
    .one {
      width: 100%;
      height: calc(100% - 25px);
    }
    
    .panel {
      display: inline-block;
      background-color: #ffffff;
    }
    
    @media print {
      @page {size: ${pageLayout};}
    }`;

  content += `
    .${pageLayout} {
      width: 100%;
      height: 100%;
      background-color: white;
      -webkit-print-color-adjust: exact;
      overflow: visible !important;
      page-break-after: always;
    }`;
    
  content += `
    </style>
    </head>
    <body>
    ${html}
    </body>
    </html>`;
  
  return content;
}

export function requestPrintInApp(data) {
  logDetailed("print", "requestPrintInApp", "trying to request print in app", data);
  return new Promise((resolve) => {
    if (window.requestPrintInApp) window.requestPrintInApp(data, resolve);
    else alertAboutPrintInApp(data, resolve);
  });
}

function alertAboutPrintInApp(data, resolve) {
  alert(JSON.stringify(data));
  resolve();
}